import { useMutation, useQuery } from 'react-query';
import { useProgramTypeDao } from 'shared/dao/programTypeDao';
import {
  IProgramTypeCreatePayload,
  IProgramTypeRequestPayload,
  IProgramTypeResponsePayload,
  IProgramTypeUpdatePayload,
} from 'shared/interfaces/IProgramType';

const PROGRAM_TYPE_OPTIONS_PAYLOAD: IProgramTypeRequestPayload = {
  page: 1,
  limit: 100,
  is_active: true,
  sort: 'sort-order-asc',
};

const {
  getProgramTypes: getProgramTypesDao,
  createProgramType: createProgramTypeDao,
  updateProgramType: updateProgramTypeDao,
  deleteProgramType: deleteProgramTypeDao,
} = useProgramTypeDao();

export const useProgramTypeService = () => {
  // Dropdown source: active types from the program-type list, in display order. Admins can add,
  // rename and re-order types at any time, so refetch whenever a form opens.
  const getProgramTypeOptions = () =>
    useQuery<IProgramTypeResponsePayload, Error>(
      ['program_types', PROGRAM_TYPE_OPTIONS_PAYLOAD],
      () => getProgramTypesDao(PROGRAM_TYPE_OPTIONS_PAYLOAD),
      { staleTime: 0, refetchOnMount: 'always' },
    );

  const getProgramTypes = (payload?: IProgramTypeRequestPayload) =>
    useQuery<IProgramTypeResponsePayload, Error>(['program_types', payload], () => getProgramTypesDao(payload), {
      keepPreviousData: true,
    });

  const createMutation = useMutation((payload: IProgramTypeCreatePayload) => createProgramTypeDao(payload));
  const updateMutation = useMutation((payload: IProgramTypeUpdatePayload) => updateProgramTypeDao(payload));
  const deleteMutation = useMutation((id: string) => deleteProgramTypeDao(id));

  return {
    getProgramTypeOptions,
    getProgramTypes,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
